export default function cartCtrl($scope, $rootScope, $http, $compile, $filter) {
    $scope.cartData = {};

    $scope.deleteCartProd = false;

    $rootScope.confirmModal = function (callback, action, oiid, curVal, _product) {
        if (typeof _product == undefined) {
            _product = false
        }
        var ret;
        $.fancybox.open({
            src: "#confirm-del-cart",
            type: "inline",
            smallBtn: false,
            clickOutside: false,
            trapFocus: false,
            touch: false,
            btnTpl: {
                smallBtn: `
                    <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
                        <i class="icon-close"></i>
                    </button>
                    `,
            },
            opts: {
                afterShow: function () {
                    try {
                        $("#confirm-del-cart .btn").unbind('click');
                    } catch (e) {

                    }
                    $("#confirm-del-cart .btn-no").click(function () {
                        ret = false;
                        //$.fancybox.close();
                        $.fancybox.close();
                    })
                    $("#confirm-del-cart .btn-yes").click(function () {
                        // /cart/decrease/{order_item_id}/{qty?}
                        ret = true;
                        if (ret == true) {
                            callback.call(this, action, oiid, 0);
                            // var datalayerPayload = {
                            //     'event': 'removeFromCart',
                            //     'ecommerce': {
                            //         'currencyCode': 'EUR',
                            //         'add': {
                            //             'products': [{
                            //                 'name': _product.title,
                            //                 'id': _product.product_id,
                            //                 'price': _product.price,
                            //                 'brand': 'Ibo Maraca',
                            //                 'category': '', //_product.byTypeTxt, TODO
                            //                 'variant': '', //_product.variant_info.title, TODO
                            //                 'quantity': 1
                            //             }]
                            //         }
                            //     }
                            // };
                            // dataLayer.push({
                            //     'event': 'removeFromCart',
                            //     'ecommerce': {
                            //         'currencyCode': 'EUR',
                            //         'add': {
                            //             'products': [{
                            //                 'name': _product.title,
                            //                 'id': _product.product_id,
                            //                 'price': _product.price,
                            //                 'brand': 'Ibo Maraca',
                            //                 'category': '', //_product.byTypeTxt, TODO
                            //                 'variant': '', //_product.variant_info.title, TODO
                            //                 'quantity': 1
                            //             }]
                            //         }
                            //     }
                            // });
                            // console.log('datalayer push', datalayerPayload)

                        }
                        $.fancybox.close();
                    })
                },
                afterClose: function () {
                    // if (typeof callback == 'function'){ 
                    //     if( ret == true ){
                    //         callback.call(this, action, oiid, curVal); 
                    //     }
                    // } 
                }
            }
        });
        //return false;
    }

    $scope.manageQuantity = function (action, oiid, curVal) {
        $rootScope.showOverlay('cart');
        var val = 0;
        var _product = $filter('filter')($scope.items, {
            id: oiid
        })[0];

        if (action == "decrease") {
            val = -1;
        } else if (action == "increase") {
            val = 1;
            var datalayerPayload = {
                'event': 'addToCart',
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'add': {
                        'products': [{
                            'name': _product.title,
                            'id': _product.product_id,
                            'price': _product.price,
                            'brand': 'Ibo Maraca',
                            'category': '', //_product.byTypeTxt, TODO
                            'variant': '', //_product.variant_info.title, TODO
                            'quantity': 1
                        }]
                    }
                }
            };

            try {
                dataLayer.push({
                    'event': 'addToCart',
                    'ecommerce': {
                        'currencyCode': 'EUR',
                        'add': {
                            'products': [{
                                'name': _product.title,
                                'id': _product.product_id,
                                'price': _product.price,
                                'brand': 'Ibo Maraca',
                                'category': '', //_product.byTypeTxt, TODO
                                'variant': '', //_product.variant_info.title, TODO
                                'quantity': 1
                            }]
                        }
                    }
                });
            } catch (error) {
                
            }
            
            console.log('datalayer push', datalayerPayload)
        } else {
            val = 0;
        }
        if (parseInt(curVal) == 1 && action == "decrease") {
            val = 0;
            $rootScope.confirmModal($scope.manageQuantity, 'decrease', oiid, curVal, _product);
            $rootScope.hideOverlay('cart');
            return false;
        }
        // console.log("/en/cart/"+action+"/"+oiid+"/"+val);
        $http({
            method: "GET",
            url: "/en/cart/"+action+"/"+oiid+"/"+val,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            dataType: "json"
        }).then(function success(response) {
            var data = response.data;
            if (data.total.items == 0 || window.location.pathname == '/en/checkout/delivery-details') {
                window.location.reload();
                return false;
            }

            if(window.location.pathname == '/en/checkout/order-details'){
                window.location.href = '/en/checkout/delivery-details';
            }

            $rootScope.session = data;
            $scope.items = data.items;
            $rootScope.hideOverlay('cart');
            $rootScope.getsession();
            $scope.getCart(true);
        }, function error(errorData) {
            var error = errorData;
            console.log('Error managequantity:', error);
            $rootScope.hideOverlay('cart');
        });
    }

    $scope.getCart = function (forceFetch) {
        if (typeof forceFetch === 'undefined') {
            forceFetch = 0;
        }

        var $el = $('.btn-bag');
        var arExpanded = false;
        try {
            arExpanded = JSON.parse($el.attr('aria-expanded'));
        } catch (e) {
            arExpanded = false;
        }

        try {
            $rootScope.$digest();
        } catch (e) {}
        if ($rootScope.session.total.items > 0 && (!arExpanded || forceFetch)) {
            $http({
                method: "GET",
                url: "/en/cart/show",
            }).then(function success(response) {
                var data = response.data;
                var cartCtrlScope = angular.element('#drawer-cart').scope();
                $("#drawer-cart>.loadedContent").html($compile(data)(cartCtrlScope));
                var ismobileCart = $('.fancybox-inner #cart-container').length;
                if (ismobileCart) {
                    $('.fancybox-inner .fancybox-slide--html').html($compile(data)($rootScope));
                }
                setTimeout(function () {
                    try {
                        $rootScope.$digest();
                    } catch (e) {}
                }, 200);
            }, function error(errorData) {
                var $data = errorData.data;
                console.log('getCart Error:', $data);
            });
        }

    }

    $rootScope.$on('getCart', function (event, data) {
        var ff = 1
        try {
            ff = data.forceFetch ? 1 : 0;
        } catch (e) {

        }

        $scope.getCart(ff);
    });
}

cartCtrl.$inject = ['$scope', '$rootScope', '$http', '$compile', '$filter'];